import styled from '@emotion/styled';
import type { MicrositeVideoData } from '~/model';
import MicrositeVideo from '~/components/MicrositeVideo';
import useIsTab from '~/hooks/useIsTab';
import { css_background } from '~/emotion/theme';

/* ── styled components ── */

const Wrapper = styled.div`
	background: ${css_background()};
	color: ${(props) => props.theme.color.black.text.strong};
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 1.5rem;
`;

const Title = styled.div`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 1.5rem;
	line-height: 2rem;
	letter-spacing: 0.3em;
	text-align: center;
	padding-top: 2rem;
	padding-bottom: 2rem;
	@media (min-width: ${(props) => props.theme.viewport.medium}px) {
		font-size: 2.25rem;
		line-height: 2.5rem;
	}
`;

const PlayerContainer = styled.div`
	flex: 1;
	position: relative;
	min-height: 300px;
	aspect-ratio: 16 / 9;
`;

const PlayerInner = styled.div`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
`;

/* ── component ── */

export default function VideoBlockEta({ title, video }: { title: string; video: MicrositeVideoData }) {
	const tab = useIsTab();

	if (tab) {
		return (
			<PlayerContainer>
				<PlayerInner>
					<MicrositeVideo video={video} />
				</PlayerInner>
			</PlayerContainer>
		);
	}

	return (
		<Wrapper>
			<Title>{title}</Title>
			<PlayerContainer>
				<PlayerInner>
					<MicrositeVideo video={video} />
				</PlayerInner>
			</PlayerContainer>
		</Wrapper>
	);
}
